import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-firm-ticket',
    templateUrl: './firm-ticket.component.html',
    styleUrls: ['./firm-ticket.component.css']
})
export class FirmTicketComponent implements OnInit {
    public firm: any;
    public searchText;

    constructor() {
    }

    ngOnInit() {
        this.firm = localStorage.getItem('firm');
    }

}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/firm-ticket/firm-ticket.component.ts